import * as React from 'react';



export default class NoVideo extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        (this.props.largeView)?
        (
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                <g fill="none" fillRule="evenodd" stroke="#D8D8D8">
                    <circle cx="21" cy="21" r="20.5"/>
                    <path d="M29.98 20.187L17.061 10.5v19.375l12.917-9.688z"/>
                </g>
            </svg>
        )
        :
        (
            <svg xmlns="http://www.w3.org/2000/svg"  className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
                <g id="Files/No-video-sm" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-17.000000, -8.000000)">
                    <g id="Video-preview-not-avail" transform="translate(6.000000, 8.000000)" stroke="#D8D8D8">
                        <g id="video-icon" transform="translate(11.000000, 0.000000)">
                            <circle id="play-circle" cx="8" cy="8" r="7.5"/>
                            <path d="M8.9333253,5.71906398 L5.86190534,9.81429059 L12.0047453,9.81429059 L8.9333253,5.71906398 Z" id="play" transform="translate(8.933333, 7.690479) rotate(90.000000) translate(-8.933333, -7.690479) "/>
                        </g>
                    </g>
                </g>
            </svg>
        )
    )
  }
}
